import ModuleGuard from '@/components/Guards/ModuleGuard';
import MODULES from '@/config/modules.config';
import { DISCLOSER_KEYS } from '@/constants/keys.constants';
import { useAppDiscloser } from '@/hooks';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import ManageRole from '../RolePermission/_components/ManageRole';
import Activity from './Summary/_components/Activity';
import SummaryHeader from './Summary/_components/SummaryHeader';
import UsersCountCard from './Summary/_components/UsersCountCard';

const Summary = () => {
  const navigate = useNavigate();
  const [dates, setDates] = useState<[Dayjs | null, Dayjs | null]>([
    dayjs().subtract(29, 'day'),
    dayjs(),
  ]);
  const [roleConfig, handleOpenRoleDrawer, handleCloseRoleDrawer] =
    useAppDiscloser(DISCLOSER_KEYS.ROLES_MANAGEMENT);

  return (
    <div>
      <SummaryHeader
        dates={dates}
        setDates={setDates}
        onOpenRoleDrawer={() => handleOpenRoleDrawer({ type: 'ADD' })}
        onNavigateToPolicies={() => navigate('/admin/control-panel/policies')}
      />

      {/* Status Card Area */}
      {/* <div className="mt-5">
        <StatusCard />
      </div> */}

      {/* Users Count Card Area */}
      <div className="mt-5">
        <UsersCountCard />
      </div>

      {/* Table Area */}
      <ModuleGuard moduleId={MODULES.CONTROL_PANEL_ACTIVITY}>
        <div className="mt-5 border border-theme-gray-700 rounded-xl">
          <Activity dates={dates} />
        </div>
      </ModuleGuard>

      <ManageRole
        data={roleConfig.data}
        open={roleConfig.open}
        handleClose={handleCloseRoleDrawer}
        id={roleConfig.data?.id}
      />
    </div>
  );
};

export default Summary;
